import { pdfjs } from "react-pdf";

/**
 * Resolves the bundled pdfjs worker URL.
 *
 * The runtime path uses webpack's asset resolution for
 * `new URL("...", import.meta.url)`. Isolating it in this module
 * lets Jest mock the helper without needing to parse
 * `import.meta` syntax in the consuming component.
 */
export const getPdfWorkerUrl = (): string =>
  new URL(
    "react-pdf/node_modules/pdfjs-dist/build/pdf.worker.min.mjs",
    import.meta.url
  ).toString();

/**
 * Sets the global pdfjs worker source for `react-pdf`.
 *
 * Safe no-op when the worker URL cannot be resolved (e.g. test runners
 * that mock this helper).
 */
export const setupPdfWorker = (): void => {
  try {
    pdfjs.GlobalWorkerOptions.workerSrc = getPdfWorkerUrl();
  } catch (err) {
    // Worker URL is optional in non-browser environments (e.g. test runners
    // that mock this helper), but a failure in a real browser means PDF
    // rendering will silently break — surface it outside of tests.
    if (process.env.NODE_ENV !== "test") {
      console.error("[pdfWorkerSetup] Failed to set worker URL:", err);
    }
  }
};
